export default __webpack_public_path__ + "static/media/hht1_ep18_minisitcom_04.51e295a6.png";